module.exports = __webpack_public_path__ + "static/media/mmIntroBingo.a1265c5b.jpg";